import { styled } from '@mui/material';

import { Icons, SxProps } from '@cast/design-system';
import { Cloud } from '@cast/shared-types';

import AwsIconBase from './assets/aws.svg';
import AzureIconBase from './assets/azure.svg';
import GcpIconBase from './assets/gcp.svg';
import OracleIconBase from './assets/oracle.svg';

const AwsIcon = styled(AwsIconBase)({});
const AzureIcon = styled(AzureIconBase)({});
const GcpIcon = styled(GcpIconBase)({});
const OracleIcon = styled(OracleIconBase)({});
const CloudIcon = styled(Icons.Cloud)({});

const svgIconByCsp: Partial<Record<Cloud, typeof GcpIcon>> = {
  [Cloud.gcp]: GcpIcon,
  [Cloud.aws]: AwsIcon,
  [Cloud.azure]: AzureIcon,
  [Cloud.oracle]: OracleIcon,
};

type Props = { csp: Cloud; size?: number; className?: string; sx?: SxProps };

export const CspIcon = ({ csp, size, className, sx }: Props) => {
  const style = size != null ? { minWidth: size } : undefined;
  const Icon = svgIconByCsp[csp];
  if (Icon) {
    return (
      <Icon
        height={size}
        width={size}
        style={style}
        className={className}
        sx={sx}
      />
    );
  }
  return (
    <CloudIcon
      height={size}
      width={size}
      style={style}
      sx={sx}
      className={className}
    />
  );
};
